var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.851,
    height: 34,
    viewBox: "0 0 44.851 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33934",
    "data-name": "\\uD328\\uC2A4 33934",
    d: "M82.17,376a2.17,2.17,0,1,0,2.17,2.17A2.17,2.17,0,0,0,82.17,376Zm0,2.894a.723.723,0,1,1,.723-.723A.723.723,0,0,1,82.17,378.894Z",
    transform: "translate(-73.489 -349.234)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33935",
    "data-name": "\\uD328\\uC2A4 33935",
    d: "M386.17,376a2.17,2.17,0,1,0,2.17,2.17A2.17,2.17,0,0,0,386.17,376Zm0,2.894a.723.723,0,1,1,.723-.723A.723.723,0,0,1,386.17,378.894Z",
    transform: "translate(-350 -349.234)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33936",
    "data-name": "\\uD328\\uC2A4 33936",
    d: "M52.737,96.97,46.226,86.843a.723.723,0,0,0-.609-.332H36.936V82.532A2.535,2.535,0,0,0,34.4,80H10.532A2.535,2.535,0,0,0,8,82.532v26.4a.723.723,0,0,0,.723.723h2.946a5.063,5.063,0,0,0,10.023,0H39.159a5.063,5.063,0,0,0,10.023,0h2.946a.723.723,0,0,0,.723-.723V97.362a.725.725,0,0,0-.115-.392ZM16.681,112.553a3.617,3.617,0,1,1,3.617-3.617,3.617,3.617,0,0,1-3.617,3.617Zm18.809-4.34h-13.8a5.063,5.063,0,0,0-10.023,0H9.447v-7.234H35.49Zm0-8.681H9.447v-17a1.086,1.086,0,0,1,1.085-1.085H34.4a1.086,1.086,0,0,1,1.085,1.085Zm11.128-9.4L50.8,96.638H40.553V90.128ZM44.17,112.553a3.617,3.617,0,1,1,3.617-3.617,3.617,3.617,0,0,1-3.617,3.617ZM51.4,102.426H49.958a.723.723,0,1,1,0-1.447H51.4Zm0-2.894H49.958a2.17,2.17,0,0,0,0,4.34H51.4v4.34H49.182a5.063,5.063,0,0,0-10.023,0H36.936V87.958h8.286l.466.723H39.83a.723.723,0,0,0-.723.723v7.958a.723.723,0,0,0,.723.723H51.4Z",
    transform: "translate(-8 -80)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33937",
    "data-name": "\\uD328\\uC2A4 33937",
    d: "M354.894,296h-2.17a.723.723,0,0,0,0,1.447h2.17a.723.723,0,0,0,0-1.447Z",
    transform: "translate(-320.893 -276.468)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33938",
    "data-name": "\\uD328\\uC2A4 33938",
    d: "M208.723,329.447h5.787a.723.723,0,0,0,0-1.447h-5.787a.723.723,0,0,0,0,1.447Z",
    transform: "translate(-189.915 -305.574)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33939",
    "data-name": "\\uD328\\uC2A4 33939",
    d: "M250.894,352h-2.17a.723.723,0,0,0,0,1.447h2.17a.723.723,0,1,0,0-1.447Z",
    transform: "translate(-226.298 -327.404)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check2.bcd484f0ffde6be8100610a46742f4ff.svg";
export { ForwardRef as ReactComponent };